<template>
    <div class="paywork_mian">

        <div class="paywork_mb" ></div>
        <div class="paywork_con">
            <div class="btn_close" @click="hide">
                <div> </div>
                <img src="../assets/images/img2/offlogin.png" alt="">
            </div>
            <div class="flex_bet_h marR">
                <img src="../assets/images/img2/workpay.png" style="width: 219px; height: 135px" />
                <div style="text-align: center">
                    <p>
                        <span style="font-size: 28px">{{ rmb }}</span>
                        <span>元</span>
                    </p>
                    <p style="font-size: 12px; color: #999999">购买本条作品需支付</p>
                </div>
            </div>
            <div class="pay_workline"></div>
            <div class="flex_bet_h flex_Dc">
                <div class="pay" @click="startOpenVip">
                    <div class="pay_height">
                        <img class="payimg" src="../assets/images/img2/work_openvip.png" style="width:20px;heigth:20px;" />
                        <span>开通会员导出</span>
                    </div>
                    <div>
                        <img src="../assets/images/img2/tuijian.png" alt="" style="width:58px;heigth:24px">
                    </div>
                </div>
                <div class="paywork_btn marT" @click="insufficient ? goToAddGold() : useGoldToBuy()">
                    <div><img src="../assets/images/img2/wprk_gold.png" /></div>
                    <span>{{ insufficient ? "前往充值金币" : "使用金币支付" }}</span>
                </div>
            </div>
            <p class="work_paytit">
                <span>现金支付</span>
                <span>仅购买本条作品</span>
            </p>
            <div class="work_paycode">
                <img :src="code_url" class="work_paycode_img" v-show="code_url" />
                <p>
                    <img src="../assets/images/img1/dubbing_wechatPay.png" class="work_paycode_icon" />
                    <span>微信支付</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        textlength: {
            type: Number,
        },
        wkid: {
            type: String,
        },
    },
    destroyed() {
        clearInterval(this.paytime);
    },
    watch: {
        $route(to, from) {
            clearInterval(this.paytime);
        },
    },
    data() {
        return {
            rmb: 100, //本次消费现金值
            jb: 1000, //本次消费金币数
            insufficient: false, //是否金币不足购买
            code_url: "", //现金购买二维码地址
            crgid: "", //现金购买订单id
            paytime: null, //监测支付状态订单
        };
    },
    mounted() {
        // 文本长度
        let textlength = parseInt(this.textlength);
        // 现金价格列表
        let ttsjblist = this.$store.state.ttsjblist;
        ttsjblist.forEach((item) => {
            if (
                textlength >= parseInt(item.txtmin) &&
                textlength <= parseInt(item.txtmax)
            ) {
                this.jb = parseInt(item.jb);
                this.rmb = parseInt(item.rmb);
            }
        });
        this.useMoneyToBuy();
    },
    methods: {
        // 验证支付
        verifyPay() {
            let self = this;
            clearInterval(self.paytime);
            this.paytime = setInterval(() => {
                if (self.crgid == "") return;
                let url =
                    self.$store.state.base_api +
                    self.$store.state.base_url.qryorderinfo;
                let json = {
                    crgid: self.crgid,
                };
                self.$request.postHttp(json, url, (decdata) => {
                    if (decdata.model.status !== "1") return;
                    //支付成功清除计时器
                    clearInterval(self.paytime);
                    self.$message({
                        message: "购买成功",
                        type: "success",
                    });
                    self.$emit("success");
                });
            }, 3000);
        },
        // 现金购买
        useMoneyToBuy() {
            let self = this;
            this.$globalFun.getPay(
                this,
                2,
                2,
                "现金购买作品",
                this.rmb,
                0,
                this.wkid,
                {},
                (res) => {
                    console.log(res);
                    self.code_url = res.model.orderparams4webchat.code_url;
                    self.crgid = res.model.crgid;
                    self.verifyPay();
                }
            );
        },
        // 开通会员
        startOpenVip() {
            this.$store.commit("showOpenvip", true);
            this.$emit("hide");
        },
        // 前往充值金币
        goToAddGold() {
            this.$router.push(`/gold`);
            this.$emit("hide");
        },
        // 金币购买作品
        useGoldToBuy() {
            let user_jb = parseInt(this.$store.state.userrich.jb);
            if (user_jb < this.jb) {
                this.insufficient = true;
                this.$message({
                    message: "账户金币不足！",
                    type: "warning",
                });
                return;
            }
            this.$globalFun.getPay(
                this,
                0,
                0,
                "金币购买作品",
                this.jb,
                0,
                this.wkid,
                {},
                (res) => {
                    if (res.rc !== "0") {
                        this.$message.error("购买失败！");
                        return;
                    }
                    this.$message({
                        message: "购买成功",
                        type: "success",
                    });
                    this.$emit("success");
                }
            );
        },
        hide() {
            this.$emit("hide");
        },
    },
};
</script>

<style>
.work_paycode_icon {
    width: 13px;
    height: 13px;
    margin-right: 4px;
}
.work_paycode_img {
    width: 100px;
    height: 100px;
    background-color: #eee;
}
.work_paycode {
    text-align: center;
}
.work_paytit {
    margin: 30px 20px 20px;
}
.work_paytit span:first-of-type {
    font-size: 16px;
}
.work_paytit span:last-of-type {
    color: #999;
    font-size: 12px;
    margin-left: 16px;
}
.paywork_btn img {
    width: 20px;
    height: 20px;
    margin-right: 16px;
}
.pay_height {
    height: 48px;
    line-height: 48px;
}
.pay {
    width: 384px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(254, 186, 7, 0.3);
    padding: 0 20px;
    border-radius: 8px;
    cursor: pointer;
}
.payimg {
    width: 20px;
    height: 20px;
    margin-right: 16px;
}
.paywork_btn {
    width: 384px;
    height: 48px;
    padding: 0 20px;
    background: #f8f8f8ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    cursor: pointer;
}
.pay_workline {
    width: 384px;
    height: 1px;
    border: 1px solid #eeeeee;
    margin: 30px auto;
    position: relative;
}
.paywork_con {
    width: 464px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    padding: 20px 20px;
    overflow: hidden;
}
.paywork_mian {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
}
.paywork_mb {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.flex_Dc {
    display: flex;
    flex-direction: column;
}
.marT {
    margin-top: 16px;
}
.btn_close{
    display: flex;
    justify-content: space-between;
    /* margin-right: 20px; */
}
.btn_close img{
    width: 14px;
    height: 14px;
}
.marR{
    margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pay_work.vue